const brand_list = {
    heard_title: "Commodity brand",
    heard_btn: "Add",
    form_ph1: "product category",
    table_label1: "Brand Name",
    table_label2: "Sort",
    table_btn1: "Edit",
    table_btn2: "Delete",
    dialog_title1: "Product Brand",
    dialog_label1: "Brand Name:",
    dialog_label2: "Brand Sort:",
    rule_msg1: "Please enter the brand order",
    rule_msg2: "The brand serial number can only be a number",
    rule_msg3: "Sequence number already exists",
    rule_msg4: "Please enter a brand name"
};

export default brand_list;
